import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';
import Promote from '../../../components/promote';

class LeftNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { homeTitle, homeList, homeHardAd, promoteInHome },
        } = this.props;

        return (
            <div className={styles.left_box}>
                <Chip id="230187" type="struct" title="家居标题" groupName="家居" content={homeTitle}>
                    <NewsTitle size="middle" />
                </Chip>
                <Chip
                    id="225757"
                    type="recommend"
                    title="家居列表"
                    groupName="家居"
                    content={homeList}
                    translate="handleNewsData">
                    <NewsList hasTitleImg size="long" />
                </Chip>
                <NoSSR>
                    <Ad content={homeHardAd} styleName={styles.dbox} />
                </NoSSR>
                {promoteInHome && (
                    <Chip id="230195" type="struct" title="铺底推广" groupName="家居" content={promoteInHome}>
                        <Promote />
                    </Chip>
                )}
            </div>
        );
    }
}

export default errorBoundary(LeftNewsBox);
